//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/ScCollector.js";
import "../no/SelectEdgeList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BendAngle",0,"Expression",0],[0,"BendExtendSection",1,0],[0,"BendInset",1,0],[1,"BendLineSection",0,"Section",0],[1,"BendRadius",0,"Expression",0],[0,"BendReverseDirection",1,0],[0,"BendReverseSide",1,0],[1,"BendTargetFace",0,"ScCollector",0],[0,"BlendEdges",1,0],[0,"BlendRibEdges",1,0],[0,"BlendTongueEdges",1,0],[1,"DieRadius",0,"Expression",0],[1,"MinimumToolClearance",0,"Expression",0],[1,"PunchRadius",0,"Expression",0],[1,"RibAngle",0,"Expression",0],[0,"RibCrossSection",1,0],[1,"RibDepth",0,"Expression",0],[0,"RibDepthDirection",1,0],[1,"RibEdgeRadius",0,"Expression",0],[0,"RibEndCondition",1,0],[1,"RibPunchWidth",0,"Expression",0],[1,"RibRadius",0,"Expression",0],[1,"RibSection",0,"Section",0],[1,"RibTaperDistance",0,"Expression",0],[1,"RibWidth",0,"Expression",0],[1,"ScrapEdges",0,"SelectEdgeList",0],[0,"ScrapStationNumber",1,0],[1,"TongueDepth",0,"Expression",0],[0,"TongueDepthDirection",1,0],[1,"TongueRadius",0,"Expression",0],[1,"TongueSection",0,"Section",0],[0,"TongueShape",1,0],[1,"TongueWidth",0,"Expression",0],[0,"TongueWidthDirection",1,0],[0,"Type",1,0]],[[["baseFace"],"ConvertToSheetMetal",{},1,0]],[]];
SPLM.Tooling.DefineProcessBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DefineProcessBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DefineProcessBuilder.Types = Object.freeze({
    "Scrap" : "Scrap", "Bend" : "Bend", "Rib" : "Rib", "Tongue" : "Tongue"});

SPLM.Tooling.DefineProcessBuilder.BendInsetOptions = Object.freeze({
    "OuterMoldLineProfile" : "OuterMoldLineProfile", "BendCenterLineProfile" : "BendCenterLineProfile", "InnerMoldLineProfile" : "InnerMoldLineProfile", "MaterialInside" : "MaterialInside", "MateiralOutside" : "MateiralOutside"});

SPLM.Tooling.DefineProcessBuilder.RibCrossSectionOptions = Object.freeze({
    "Circular" : "Circular", "UShaped" : "UShaped", "VShaped" : "VShaped"});

SPLM.Tooling.DefineProcessBuilder.RibEndConditionOptions = Object.freeze({
    "Formed" : "Formed", "Lanced" : "Lanced", "Punched" : "Punched", "Tapered" : "Tapered"});

SPLM.Tooling.DefineProcessBuilder.TongueShapeOptions = Object.freeze({
    "Lanced" : "Lanced", "Formed" : "Formed"});

export default SPLM;